import React, { useEffect, useRef, useState } from "react";
import "./Conversation.css";
import {
  Row,
  Col,
  Button,
  Input,
  Badge,
  Avatar,
  Empty,
  Tooltip,
  Switch,
  Tabs,
  Dropdown,
  Menu,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBell,
  faBellSlash,
  faComments,
  faUser,
  faUsersRectangle,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { setChatSpace } from "../../Redux/ChatSpaceSlice";
import { setPopup } from "../../Redux/PopupSlice";
import axios from "axios";

function Conversation() {
  const [visibleMessageSetting, setVisibleMessageSetting] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const messSettingPopupRef = useRef(null);
  const user = localStorage.getItem("userInfo");
  const userId = JSON.parse(user).id;
  const fetchConversation = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/conversation/get-all/${userId}`
      );
      setConversations(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.log("Error fetching conversations:", error);
    }
  };

  const handleSearch = async (value) => {
    setSearchQuery(value); // Store the search query
    if (!value) {
      setSearchResults([]); // Reset search results if input is empty
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/user/get-by-search?username=${value}`
      );
      const users = response.data;
      setSearchResults(users); // Update search results with users
    } catch (error) {
      console.log("Error searching users:", error);
    }
  };

  const handleSelectUser = async (user) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/conversation/start`,
        {
          partnerId: user._id,
          userId: userId,
        }
      );

      // Use the dispatch from component scope
      dispatch(setChatSpace({ open: "message", info: response.data.data }));
      dispatch(setPopup(null));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchConversation();
  }, []);

  const tabList = [
    {
      key: "1",
      label: <span>Danh sách</span>,
      children: <ConversationList conversations={conversations} />,
    },
    {
      key: "2",
      label: <span>Tin nhắn lạ</span>,
      children: <ConversationList conversations={[]} />,
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        messSettingPopupRef.current &&
        !messSettingPopupRef.current.contains(event.target)
      ) {
        setVisibleMessageSetting(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const searchMenu = (
    <Menu>
      {searchResults.length > 0 ? (
        searchResults.map((user) => (
          <Menu.Item key={user._id} onMouseDown={() => handleSelectUser(user)}>
            <Row align="middle">
              <Col span={4}>
                <Avatar src={user.avatar || "https://picsum.photos/200/300"} />
              </Col>
              <Col span={20}>
                <span>{user.username}</span>
              </Col>
            </Row>
          </Menu.Item>
        ))
      ) : (
        <Menu.Item>No Users Found</Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <Row
        className="conversationHeader"
        align={"middle"}
        justify={"space-between"}
      >
        <Col className="conversationTitle" span={12}>
          <h2>Đoạn chat</h2>
        </Col>
        <Col className="conversationFunction" span={12}>
          <Tooltip
            placement="bottomRight"
            title={<MessageSetting />}
            color="whiteSmoke"
            overlayStyle={{ width: "500px" }}
            open={visibleMessageSetting}
          >
            <Button
              onClick={() => setVisibleMessageSetting((prev) => !prev)}
              className="functionBtn"
              shape="circle"
            >
              <div ref={messSettingPopupRef}>
                <FontAwesomeIcon icon={faBars} />
              </div>
            </Button>
          </Tooltip>
        </Col>
        <Col span={24}>
          {/* <Input className="conversationSearch" placeholder="Tìm tin nhắn" /> */}
          <Dropdown
            overlay={searchMenu}
            visible={searchQuery.length > 0 && searchResults.length > 0}
            trigger={["click"]}
          >
            <Input
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Tìm người hoặc tin nhắn"
            />
          </Dropdown>
        </Col>
      </Row>
      <Tabs
        defaultActiveKey="1"
        items={tabList}
        size="small"
        tabBarStyle={{ marginBottom: "10px" }}
      />
    </>
  );
}

function ConversationList({ conversations = [] }) {
  const dispatch = useDispatch();
  return (
    <>
      {!Array.isArray(conversations) || conversations.length <= 0 ? (
        <Empty description="Hiện chưa có tin nhắn nào gửi đến bạn" />
      ) : (
        conversations.map((c, index) => {
          const isNewComming = index % 2 === 0;
          return (
            <Row
              key={c.conversationId}
              align={"middle"}
              className="conversationWrapper"
              onClick={() => {
                dispatch(setChatSpace({ open: "message", info: c }));
                dispatch(setPopup(null));
              }}
            >
              <Col span={4}>
                <Avatar.Group>
                  {[...Array(1)].map((_, index) => (
                    <Avatar
                      key={index}
                      shape="circle"
                      size={[...Array(1)].length === 1 ? 40 : 30}
                      style={{ marginLeft: index === 0 ? 0 : -15 }}
                      src="https://picsum.photos/200/300"
                      icon={<FontAwesomeIcon icon={faUser} />}
                    />
                  ))}
                </Avatar.Group>
              </Col>
              <Col span={20} className="conversationContent">
                <span className="conversationName">{c.partnerName}</span>
                <span
                  className={`conversationInfo ${isNewComming && "newComming"}`}
                >
                  {(
                    <>
                      <span className="messagePreviewText">bruh</span>{" "}
                      <span className="messagePreviewTimeAgo">3 min</span>
                    </>
                  ) || <span>hãy bắt đầu cuộc trò chuyện với John Doe</span>}
                </span>
              </Col>
            </Row>
          );
        })
      )}
    </>
  );
}

function MessageSetting() {
  const dispatch = useDispatch();
  const [switchTest, setSwitchTest] = useState(true);
  return (
    <Row
      align={"middle"}
      style={{ color: "black" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Col span={24}>
        <h3 className="messSettingHeader">Cài đặt chat</h3>
      </Col>
      <Col span={24} className="messSettingOption">
        <Row
          className="messSettingTitleWrapper"
          onClick={() => {
            dispatch(setChatSpace({ open: "createGroup", info: null }));
            dispatch(setPopup(null));
          }}
        >
          <Col span={2} className="messSettingIcon">
            <FontAwesomeIcon icon={faUsersRectangle} />
          </Col>
          <Col span={16}>
            <span className="messSettingTitle choose">Tạo nhóm</span>
          </Col>
          <Col span={6}></Col>
        </Row>
      </Col>
      <Col span={24} className="messSettingOption">
        <Row
          className="messSettingTitleWrapper"
          onClick={() => setSwitchTest((prev) => !prev)}
        >
          <Col span={2} className="messSettingIcon">
            <FontAwesomeIcon icon={switchTest ? faBell : faBellSlash} />
          </Col>
          <Col span={16}>
            <span className="messSettingTitle">
              {switchTest ? "Tắt thông báo" : "Bật thông báo"}
            </span>
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Switch checked={switchTest} size="small" />
          </Col>
        </Row>
      </Col>
      <Col span={24} className="messSettingOption">
        <Row className="messSettingTitleWrapper" onClick={() => {}}>
          <Col span={2} className="messSettingIcon">
            <FontAwesomeIcon icon={faComments} />
          </Col>
          <Col span={16}>
            <span className="messSettingTitle">
              Chỉ nhận tin nhắn khi đã theo dõi nhau
            </span>
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Switch checked={false} size="small" />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Conversation;
